
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator'
import debounce from 'lodash/debounce'
import { OnBeforeDestroy, OnMounted, OnUpdated } from '~/core/vue.types'

@Component({})
export default class AppAccordionItem extends Vue implements OnMounted, OnBeforeDestroy, OnUpdated {
  @Prop({ type: String, required: true })
  private readonly title!: string

  @Prop({ type: String, required: true })
  private readonly prefix!: string

  @Ref('content')
  private readonly content!: Element

  private contentHeight = 0

  private debouncedOnResize = debounce(this.calculateContentHeight, 500)

  mounted () {
    this.calculateContentHeight()
    window.addEventListener('resize', this.debouncedOnResize)
  }

  updated () {
    this.$nextTick(() => {
      this.calculateContentHeight()
    })
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.debouncedOnResize)
  }

  calculateContentHeight (): void {
    const children = Array.from(this.content.childNodes).filter(
      item => item.nodeType === 1,
    ) as Element[]
    this.contentHeight = children.reduce((prev, current) => {
      return prev + current.getBoundingClientRect().height
    }, 0)
  }
}
